import React, { useEffect, useRef, useState } from "react";

// Подписи для опций разгрузки — отдельный справочник, чтобы не плодить
// бизнес-данные в UI-компоненте. Ключи соответствуют UNLOAD_METHOD_OPTIONS.
const UNLOAD_OPTION_HINTS = {
  "разгрузка манипулятором": "дешевле для 1–2 шаланд · кладёт прямо на площадку",
  "разгрузка краном": "дешевле от 3 шаланд · универсально",
  "без разгрузки": "если у клиента своя техника",
};

function UnloadMethodSelect({ value, options, onChange }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  // Закрытие popover при клике вне компонента.
  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleDocumentClick = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleDocumentClick);
    return () => document.removeEventListener("mousedown", handleDocumentClick);
  }, [open]);

  const handleToggle = () => setOpen((prev) => !prev);

  const handlePick = (option) => {
    setOpen(false);
    if (option === value) {
      return;
    }
    onChange({ target: { value: option } });
  };

  return (
    <div className="rd-unload-select" ref={rootRef}>
      <button
        type="button"
        className={`rd-unload-select__trigger${open ? " rd-unload-select__trigger--open" : ""}`}
        onClick={handleToggle}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="rd-unload-select__value">{value || "Выберите способ"}</span>
        <span className="rd-unload-select__chevron" aria-hidden="true" />
      </button>

      {open && (
        <div className="rd-unload-select__menu" role="listbox">
          {options.map((option) => {
            const picked = option === value;
            return (
              <div
                key={option}
                role="option"
                aria-selected={picked}
                className={`rd-unload-select__item${picked ? " rd-unload-select__item--picked" : ""}`}
                onClick={() => handlePick(option)}
              >
                <span className="rd-unload-select__check" aria-hidden="true" />
                <span className="rd-unload-select__txt">
                  <span className="rd-unload-select__name">{option}</span>
                  {UNLOAD_OPTION_HINTS[option] && (
                    <small className="rd-unload-select__hint">{UNLOAD_OPTION_HINTS[option]}</small>
                  )}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default UnloadMethodSelect;
